import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} fill="#fff" />
        <rect x={0.5} y={0.5} width={39} height={39} rx={19.5} stroke={theme["#B4E3E1"]} />
        <path
            d="M28.333 20c0-4.592-3.742-8.334-8.334-8.334-4.591 0-8.333 3.742-8.333 8.334a8.312 8.312 0 002.692 6.116c0 .009 0 .009-.009.017.084.084.184.15.267.225.05.042.092.084.142.117.15.125.316.241.475.358l.166.117c.159.108.325.208.5.3.059.033.125.075.184.108.166.092.341.175.525.25.066.034.133.067.2.092.183.075.366.142.55.2.066.025.133.05.2.067.2.058.4.108.6.158.058.017.116.033.183.041.233.05.467.084.708.109.034 0 .067.008.1.017.284.024.567.041.85.041.284 0 .567-.016.842-.041a.415.415 0 00.1-.017c.242-.025.475-.058.708-.108.059-.009.117-.034.184-.042.2-.05.408-.092.6-.159.066-.024.133-.05.2-.066.183-.067.375-.125.55-.2.066-.025.133-.058.2-.092.175-.075.35-.158.525-.25.066-.033.125-.075.183-.108.167-.1.333-.192.5-.3.058-.034.108-.075.167-.117.166-.116.325-.233.475-.358.05-.042.091-.084.141-.117.092-.075.184-.15.267-.225 0-.008 0-.008-.008-.017a8.288 8.288 0 002.7-6.116zm-4.217 4.142c-2.258-1.517-5.958-1.517-8.233 0a4.025 4.025 0 00-.917.833A7.066 7.066 0 0112.916 20a7.088 7.088 0 017.083-7.084A7.088 7.088 0 0127.083 20a7.067 7.067 0 01-2.05 4.975 3.858 3.858 0 00-.917-.834z"
            fill={theme["#0D968F"]}
        />
        <path
            d="M20 15.775a3.126 3.126 0 00-3.125 3.125c0 1.692 1.325 3.067 3.083 3.117H20.108a3.12 3.12 0 003.017-3.117c0-1.725-1.4-3.125-3.125-3.125z"
            fill={theme["#0D968F"]}
        />
        </svg>
    )
}
  
  export default SvgComponent